export function validEmpty (str) {
  return str.trim().length == 0
}

export function validNString (str) {
  if (!str) {
    return true
  } else {
    return str.trim().length == 0
  }
}

export function validNArray (arr) {
  return arr.length == 0
}

export function validNObject (obj) {
  for (let key in obj) {
    return false
  }
  return true
}

export function validNumber (str) {
  return Number.isInteger(parseInt(str))
}

const Num = /^[0-9]*$/
export function validNum (str) {
  if (!Num.test(str)) {
    return true
  } else {
    return false
  }
}

const EmailReg = new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$')
export function validEmail (email) {
  if (!EmailReg.test(email)) {
    return false
  } else {
    return true
  }
}

const PhoneReg = new RegExp('^[1][3,4,5,6,7,8,9][0-9]{9}$')
export function validPhone (phone) {
  if (!PhoneReg.test(phone)) {
    return false
  } else {
    return true
  }
}

const CardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
export function validIdCard (card) {
  if (!CardReg.test(card)) {
    return false
  } else {
    return true
  }
}

const SecureCodeReg = /^[9]{2}[0|7-9]$/
export function valiSecureCode (code) {
  if (SecureCodeReg.test(code)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js